<template>
  <div class="popup-reset-password">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div id="waiting" class="center" v-if="loading"></div>
      <div class="popup-header">
        <p class="title">
          パスワードを忘れですか？
        </p>
        <p class="description">
          以下にご登録済みの{{ id }}をご入力の上、お送りください。<br>
          {{ text }}
        </p>
      </div>
      <el-form :rules="rules" :model="inputForm" ref="inputForm" id="form" @submit.prevent="send('inputForm')">
        <el-form-item prop="mail_address" :error="message" v-if="site == $siteType.site_admin">
          <el-input :placeholder="$t('mail_address')" v-model.trim="inputForm.mail_address" name="mail_address"/>
        </el-form-item>
        <el-form-item prop="login_id" :error="message" v-if="site == $siteType.site_partner">
          <el-input :placeholder="$t('partners.reset.password.placeholder.login_id')" v-model.trim="inputForm.login_id" name="login_id"/>
        </el-form-item>
        <input type="hidden" name="_token" :value="csrf">
        <div class="form-footer mb-25">
          <el-button class="btn-login" @click="send('inputForm')">{{ $t('btn_send_mail') }}</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { requestForgotPassword } from '../../api/auth'
  export default {
    props: {
      urls: { type: Object, required: true, default: [] },
      openFormReset: { type: Boolean, required: true, default: false },
      site: { type: Number, required: false }
    },
    emits: ['isOpenNoti', 'isClosePopupReset'],
    data() {
      return {
        outerVisible: false,
        innerVisible: false,
        dialog: '',
        inputForm: {
          mail_address: "",
          login_id: ""
        },
        rules: {
          mail_address: [
            { required: true, message: this.$t('errors.required', [this.$t('mail_address')]), trigger: 'blur' },
            { type: "email", message: this.$t('errors.mail'), trigger: 'blur' }
          ],
          login_id: [
            { required: true, message: this.$t('errors.required', [this.$t('login_id')]), trigger: 'blur' },
          ]
        },
        isClose: false,
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        loading: false,
        message: '',
      };
    },
    methods: {
      handleClose() {
        this.$emit('isClosePopupReset');
      },
      send(formName) {
        document.querySelector(".el-dialog__body").classList.add("disabled");
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.message = '';
            requestForgotPassword(this.urls.sendMailForgotPassword, this.inputForm)
            .then(response => response.json())
            .then(response => {
              if (response.status_code === 200) {
                this.handleClose();
                this.$emit('isOpenNoti');
              } else {
                this.message = response.message_error;
              }
            })
            .catch((error) => {})
            .finally(() => {
              document.querySelector(".el-dialog__body").classList.remove("disabled");
              this.loading = false;
            });
          } else {
            document.querySelector(".el-dialog__body").classList.remove("disabled");
            this.loading = false;
            return false;
          }
        });
      },
    },
    created() {
      this.dialog = this.openFormReset;
    },
    computed: {
      id() {
        return (this.site == this.$siteType.site_partner) ? this.$t('login_id') : this.$t('mail_address');
      },
      text() {
        return (this.site == this.$siteType.site_partner) ? '登録メール宛に再設定のURLを通知します。' : 'お送りいただいたメール宛にパスワードを通知します。';
      }
    }
  }
</script>

<style lang="scss">
  .popup-reset-password {
    .el-dialog {
      --el-dialog-width: 760px;
      --el-dialog-margin-top: 8vh;
      height: 611px;
      .el-dialog__body {
        margin-top: 10%;
        .el-form {
          width: 412px;
        }
      }
    }
  }
</style>
